import React from "react";
import { Scrollbar } from "@ann/web-components";
import { ScrollableContainer, ScrollContent } from "./ScrollableCardContent.styled";

const ScrollableCardContent = ({ children, maxHeight = "300px" }) => {
  return (
    <ScrollableContainer $maxHeight={maxHeight}>
      <Scrollbar size="small" style={{ height: "100%", flex: 1, minHeight: 0 }}>
        <ScrollContent>{children}</ScrollContent>
      </Scrollbar>
    </ScrollableContainer>
  );
};

export default ScrollableCardContent;
